import { render, staticRenderFns } from "./diagnosticRecordsMore.vue?vue&type=template&id=5a7958a1&scoped=true"
import script from "./diagnosticRecordsMore.vue?vue&type=script&lang=js"
export * from "./diagnosticRecordsMore.vue?vue&type=script&lang=js"
import style0 from "./diagnosticRecordsMore.vue?vue&type=style&index=0&id=5a7958a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7958a1",
  null
  
)

export default component.exports